const TABLET = 768;
const DESKTOP = 1025;
const EARTH_RADIUS_KM = 6371;

/**
 * Returns true if the device window is mobile size
 * @returns {boolean} Is mobile or not
 */
function isMobile() {
  return window.matchMedia(`(max-width:${TABLET - 1}px)`).matches;
}

/**
 * Returns true if the device window is desktop size
 * @returns {boolean} Is desktop or not
 */
function isDesktop() {
  return window.matchMedia(`(min-width:${DESKTOP}px)`).matches;
}

/**
 * Returns header and ticker height
 * @returns {boolean} Is mobile or not
 */
function getHeaderHeight() {
  const announcementBarSection = document.querySelector('.announcement-bar-section');
  const globaleTicker = document.querySelector('.ge-free-shipping-container');
  const header = document.querySelector('.section-header');
  const tickerHeight = announcementBarSection?.getBoundingClientRect().height || 0;
  const globaleTickerHeight = globaleTicker?.getBoundingClientRect().height || 0;
  const headerHeight = header?.getBoundingClientRect().height || 0;
  return tickerHeight + globaleTickerHeight + headerHeight;
}

/**
 * Delegate event
 * @param {string} eventName event name
 * @param {string} elementSelector delegated element selector
 * @param {function} handler function to be executed
 */
function delegateEvent(eventName, elementSelector, handler) {
  document.addEventListener(
    eventName,
    function(event) {
      // eslint-disable-next-line @babel/no-invalid-this
      for (let target = event.target; target && target !== this; target = target.parentNode) {
        if (target.matches(elementSelector)) {
          handler(event);
          break;
        }
      }
    },
    false,
  );
}

/**
 * Close all opened custom drawers
 */
function closeAllDrawers() {
  const customDrawers = document.querySelectorAll('.custom-drawer');
  customDrawers.forEach((drawer) => {
    drawer.close();
  });
}

/**
 * Get nearby locations passing origin location with latitude and longitude, and list of points and maxDistanceKm
 * @param {Object} originLocation Latitude and longitude of origin
 * @param {Array} points List of points with latitude and longitude
 * @param {number} maxDistanceKm Max distance in km
 */
function getNearbyStores(originLocation, points, maxDistanceKm = 50) {
  const toRadians = (degrees) => degrees * (Math.PI / 180);

  const haversineDistance = (coord1, coord2) => {
    const coord1Lat = parseFloat(coord1.lat);
    const coord2Lat = parseFloat(coord2.lat);
    const coord1Lon = parseFloat(coord1.lon);
    const coord2Lon = parseFloat(coord2.lon);
    const deltaLat = toRadians(coord2Lat - coord1Lat);
    const deltaLon = toRadians(coord2Lon - coord1Lon);

    const lat1Rad = toRadians(coord1Lat);
    const lat2Rad = toRadians(coord2Lat);

    const sinDeltaLat = Math.sin(deltaLat / 2);
    const sinDeltaLon = Math.sin(deltaLon / 2);

    const haversineFormula = (sinDeltaLat ** 2) +
      ((Math.cos(lat1Rad) * Math.cos(lat2Rad)) * (sinDeltaLon ** 2));

    const centralAngle = 2 * Math.atan2(Math.sqrt(haversineFormula), Math.sqrt(1 - haversineFormula));

    return EARTH_RADIUS_KM * centralAngle;
  };

  return points.filter((store) => {
    const distance = haversineDistance(originLocation, store);
    return distance <= maxDistanceKm;
  });
}

/**
 * Obtain register of indexed db passing database name, store name and register key
 * @param {Object} databaseName Database name
 * @param {Array} storeName Store name
 * @param {number} key Register key
 */
function obtainLocationInIndexedDB(databaseName, storeName, key) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(databaseName);

    request.onsuccess = function(event) {
      const db = event.target.result;
      const transaction = db.transaction(storeName, 'readonly');
      const store = transaction.objectStore(storeName);
      const getRequest = store.get(key);

      getRequest.onsuccess = function(successEvent) {
        const registro = successEvent.target.result;
        if (registro) {
          resolve(registro);
        } else {
          reject(new Error('Register not found'));
        }
      };

      getRequest.onerror = function(errorEvent) {
        reject(new Error(`Error obtaining register: ${errorEvent.target.error}`));
      };
    };

    request.onerror = function(event) {
      reject(new Error(`Error opening database: ${event.target.error}`));
    };
  });
}
